<template>
  <div class="toc_tree">
    <div class="tree_node">
      <button v-b-toggle="'nodeRow_' + node.uuid" class="icon_container btn_transprnt" :disabled="structure && structure.length === 0">
        <span class="icon icon-collapse" aria-label="collapse">
          <span class="visibility_hide">collapse</span></span>
        <span class="icon icon-expand" aria-label="expand">
          <span class="visibility_hide">expand</span>
        </span>
      </button>
      <span class="title_container">
        <span v-if="node.entityType === 'folder'" class="entity_icon" :class="'icon-' + node.entityType"></span>
        <span v-else class="entity_icon" :class="'ic-' + node.entityType"></span>
        <span class="title ace_sec_txt" v-if="node.entityType === 'folder'" :title="node.title" :aria-label="node.title">{{ node.title }}</span>
        <span class="title_entity ace_sec_txt" :aria-label="node.title" v-else @click="changeEntity(node)" :title="node.title" :class="'status_'+statusClass(node.courseStatus)" style="max-width: calc(100% - 130px);">{{ node.title }}</span>
        <template v-if="node.entityType === 'folder'">
          <template v-if="node.title === 'My Jobs' || node.title === 'My Clubs' || node.title === 'My Events'">
            <span :id="'verificationText-' + node.uuid" class="float-right" v-html="coCurricularVerificaionText(node)"></span>
          </template>
        </template>
        <template v-else>
          <template v-if="node.entityType === 'job' || node.entityType === 'club' || node.entityType === 'event'">
            <span class="float-right">
              <span class="mr-2 align-top">Verified</span>
              <span>
                <toggle-button :value="node.verified" :sync="true" :labels="{checked: 'Yes', unchecked: 'No'}" :width="60" :height="25" :font-size="15" :color="{checked: '#407c45', unchecked: '#8b1c08', disabled: getDisabledColor(node.verified)}" @change="updateVerification(node, $event)" :disabled="isOwner || node.verified"/>
              </span>
              <template v-if="isOwner && !node.verified">
                <template v-if="node.notifyAdvisor">
                  <span class="align-top">Advisor Verification Requested</span>
                </template>
                <template v-else>
                  <span class="align-top" style="cursor: pointer; color: #157099;" @click="sendVerificationRequest(node)">Request Advisor for Verification</span>
                </template>
              </template>
            </span>
          </template>
        </template>
      </span>
      <template v-if="node.entityType === 'job' || node.entityType === 'club' || node.entityType === 'event'">
        <div class="ml-2">
          <span v-html="changeDateFormat(node.startDate, 'Start Date:')"></span>
          <span v-html="changeDateFormat(node.endDate, 'End Date:')"></span>
        </div>
      </template>
    </div>
    <div class="inner_level">
      <b-collapse :id="'nodeRow_' + node.uuid">
        <ul v-if="structure && structure.length > 0">
          <node v-for="substream in structure" :node="substream" :isOwner="isOwner"></node>
        </ul>
      </b-collapse>
    </div>
  </div>
</template>
<script>
  import '../../../assets/module/css/common/pgLftTree.min.css'
  import { mapState, mapActions } from 'vuex'
  import { DateTime } from 'luxon'
  
  export default {
    name: 'node',
    props: ['node', 'isCategoryView', 'isOwner'],
    methods: {
      ...mapActions([
        'loadStreamEntity',
        'loadStreamEntityVerification'
      ]),
      changeEntity (entity) {
        if (entity.entityType !== 'folder') {
          this.loadStreamEntity(entity)
        }
      },
      async updateVerification (entity, ev) {
        if (ev) {
          entity.verified = ev.value
          entity.verification = (ev.value) ? 'verified' : 'pending'
        }
        let result = await this.loadStreamEntityVerification(entity)
        this.node = result[entity.uuid]
        let parent = result[entity.parentId]
        let text = this.coCurricularVerificaionText(parent)
        $('#verificationText-' + parent.uuid).html(text)
      },
      async sendVerificationRequest (entity) {
        entity.notifyAdvisor = true
        this.updateVerification(entity)
      },
      statusClass (status) {
        if (status === 0) {
          return 'NOT_STARTED'
        } else if (status === 1) {
          return 'INPROGRESS'
        } else if (status === 2) {
          return 'COMPLETED'
        } else if (status === 3) {
          return 'TRANSFERRED'
        } else if (status === 6) {
          return 'EXCLUDED'
        } else {
          return ''
        }
      },
      coCurricularVerificaionText (node) {
        if (node.structure && node.structure.length > 0) {
          let isAllVerified = false
          let children = JSON.parse(node.structure)
          children.forEach(entity => {
            isAllVerified = (entity.verification === 'verified')
          })
          if (isAllVerified) {
            return '<span style="color: #7aa16d;">All Co-curricular Details Verified</span>'
          }
          return '<span style="color: #c77577;">Co-curricular Details To Be Verified</span>'
        } else {
          return ''
        }
      },
      changeDateFormat (date, type) {
        if (date) {
          return type + ' <strong>' + DateTime.fromISO(date).toFormat('MM/dd/yyyy') + '</strong>'
        }
        return ''
      },
      getDisabledColor (isVerified) {
        return isVerified ? '#407c45' : '#8b1c08'
      }
    },
  
    computed: {
      ...mapState({
        'stream': state => state.stream.stream
      }),
      structure () {
        if (this.node && this.node.structure) {
          return JSON.parse(this.node.structure)
        } else {
          return []
        }
      }
    }
  }
</script>
<style scoped>
  .status_EXCLUDED {
    color: #969696 !important;
  }
</style>


// WEBPACK FOOTER //
// src/app/stream/components/NodeTree.vue